import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faUsers,
  faListAlt,
  faBuilding,
  faHistory
} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import PageHeader from '../../../../common/PageHeader';
import api from '@services/api';
import ManageEntityModal from './components/ManageEntityModal';
import ParticipantsOffcanvas from './components/ParticipantsOffcanvas';
import ParticipantsSummaryModal from './components/ParticipantsSummaryModal';
import WishesModal from './components/WishesModal';
import SalonInfoCards from './components/SalonInfoCards';
import MeetingsCard from './components/MeetingsCard';
import SalonLogsModal from './components/SalonLogsModal';

const ShowPartnerSalons = () => {
  const { id } = useParams();
  const [salon, setSalon] = useState({});
  const [partners, setPartners] = useState([]);
  const [salonPartners, setSalonPartners] = useState([]);
  const [showPartnersModal, setShowPartnersModal] = useState(false);
  const [
    showPartnerpartnerParticipantsOffcanvas,
    setshowPartnerpartnerParticipantsOffcanvas
  ] = useState(false);
  const [currentPartner, setCurrentPartner] = useState(null);
  const [showAllParticipantsModal, setShowAllParticipantsModal] =
    useState(false);

  const [partnerParticipants, setpartnerParticipants] = useState([]);
  const [newPartnerParticipant, setnewPartnerParticipant] = useState({
    firstname: '',
    lastname: '',
    partner_id: ''
  });

  const [companies, setCompanies] = useState([]);
  const [salonCompanies, setSalonCompanies] = useState([]);
  const [showCompaniesModal, setShowCompaniesModal] = useState(false);
  const [
    showCompanyParticipantsOffcanvas,
    setShowCompanyParticipantsOffcanvas
  ] = useState(false);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [companyParticipants, setCompanyParticipants] = useState([]);
  const [newCompanyParticipant, setNewCompanyParticipant] = useState({
    firstname: '',
    lastname: '',
    company_id: ''
  });
  const [showWishesModal, setShowWishesModal] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [showLogsModal, setShowLogsModal] = useState(false);

  useEffect(() => {
    const fetchSalonDetails = async () => {
      try {
        const response = await api.get(`/admin/partner-salons/${id}`);
        if (response.data.success) {
          const salonData = response.data.data;
          setSalon(salonData);
          setSalonPartners(salonData.salon_partners || []);
          setSalonCompanies(salonData.salon_companies || []);
          setPartners(salonData.all_partners || []);
          setCompanies(salonData.all_companies || []);

          // Si vous avez des états pour les participants
          if (salonData.partner_participants) {
            setpartnerParticipants(salonData.partner_participants);
          }
          if (salonData.company_participants) {
            setCompanyParticipants(salonData.company_participants);
          }
        } else {
          toast('Erreur lors du chargement du salon');
        }
      } catch (error) {
        console.error('Error fetching salon details:', error);
        toast('Une erreur est survenue lors du chargement des données');
      }
    };

    fetchSalonDetails();
  }, [id]);

  const handleOpenLogsModal = () => {
    setShowLogsModal(true);
  };

  const handleCloseLogsModal = () => {
    setShowLogsModal(false);
  };

  // Gérer l'ajout en temps réel d'un participant
  const handleAddPartnerParticipant = newParticipant => {
    setpartnerParticipants(prev => [...prev, newParticipant]);

    // Mettre à jour le compteur de participants pour ce partenaire
    setSalonPartners(prev =>
      prev.map(partner =>
        partner.id === newParticipant.partner_id
          ? {
              ...partner,
              participants_count: (partner.participants_count || 0) + 1
            }
          : partner
      )
    );

    // Reset le formulaire
    setnewPartnerParticipant({
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      partner_id: currentPartner ? currentPartner.id : ''
    });
  };

  const handleAddCompanyParticipant = newParticipant => {
    setCompanyParticipants(prev => [...prev, newParticipant]);

    // Mettre à jour le compteur de participants pour cette entreprise
    setSalonCompanies(prev =>
      prev.map(company =>
        company.id === newParticipant.company_id
          ? {
              ...company,
              participants_count: (company.participants_count || 0) + 1
            }
          : company
      )
    );

    // Reset le formulaire
    setNewCompanyParticipant({
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      company_id: currentCompany ? currentCompany.id : ''
    });
  };

  const handleOpenParticipantWishes = async (participant, type) => {
    try {
      // Charger les vœux du participant sélectionné
      // CORRECTION DE L'URL
      const endpoint = `/admin/partner-salons/${id}/wishes/${type}/${participant.id}`;

      const response = await api.get(endpoint);

      if (response.data.success) {
        // Mettre à jour le participant avec ses vœux actuels
        setSelectedParticipant({
          ...participant, // Conserver les autres infos du participant
          type, // Assurer que le type est bien passé
          wishes: response.data.data || [] // Les vœux sont dans response.data.data
        });
        setShowWishesModal(true);
      } else {
        toast('Impossible de charger les vœux du participant');
      }
    } catch (error) {
      console.error('Erreur lors du chargement des vœux:', error);
      toast('Une erreur est survenue lors du chargement des vœux');

      setSelectedParticipant({
        ...participant,
        type,
        wishes: participant.wishes || [] // Utiliser les vœux existants s'ils sont déjà chargés, sinon un tableau vide
      });
      setShowWishesModal(true);
    }
  };

  // Fonctions pour la modal sociétés
  const handleOpenCompaniesModal = async () => {
    setShowCompaniesModal(true);
  };

  const handleCloseCompaniesModal = () => {
    setShowCompaniesModal(false);
  };

  // Fonctions pour l'offcanvas des participants sociétés
  const handleOpenCompanyParticipantsOffcanvas = company => {
    setCurrentCompany(company);
    setShowCompanyParticipantsOffcanvas(true);
  };

  const handleCloseCompanyParticipantsOffcanvas = () => {
    setCurrentCompany(null);
    setShowCompanyParticipantsOffcanvas(false);
  };

  const handleNewCompanyParticipantChange = e => {
    setNewCompanyParticipant({
      ...newCompanyParticipant,
      [e.target.name]: e.target.value
    });
  };

  const handleOpenPartnersModal = () => {
    setShowPartnersModal(true);
  };

  const handlePartnersUpdate = data => {
    setSalon(data);
    setSalonPartners(data.salon_partners || []);

    if (data.partner_participants) {
      setpartnerParticipants(data.partner_participants);
    } else if (data.partnerParticipants) {
      setpartnerParticipants(data.partnerParticipants);
    }
  };

  const handleOpenParticipantWishesFromOffcanvas = async (
    participant,
    type
  ) => {
    // Fermer d'abord l'offcanvas correspondant
    if (type === 'partner') {
      handleClosepartnerParticipantsOffcanvas();
    } else {
      handleCloseCompanyParticipantsOffcanvas();
    }

    // Puis appeler la fonction normale après un court délai pour laisser le temps à l'offcanvas de se fermer
    setTimeout(() => {
      handleOpenParticipantWishes(participant, type);
    }, 300); // 300ms devrait suffire pour l'animation de fermeture
  };

  const handleCompaniesUpdate = data => {
    setSalon(data);
    setSalonCompanies(data.salon_companies || []);

    if (data.company_participants) {
      setCompanyParticipants(data.company_participants);
    } else if (data.companyParticipants) {
      setCompanyParticipants(data.companyParticipants);
    }
  };

  const handleOpenPartnerParticipantsOffcanvas = partner => {
    setCurrentPartner(partner);
    setshowPartnerpartnerParticipantsOffcanvas(true);
  };

  const handleClosepartnerParticipantsOffcanvas = () => {
    setCurrentPartner(null);
    setshowPartnerpartnerParticipantsOffcanvas(false);
  };

  const handleOpenAllParticipantsModal = () => {
    setShowAllParticipantsModal(true);
  };

  const handlenewPartnerParticipantChange = e => {
    setnewPartnerParticipant({
      ...newPartnerParticipant,
      [e.target.name]: e.target.value
    });
  };

  const handleRemovePartnerParticipant = participantId => {
    const newpartnerParticipants = partnerParticipants.filter(
      participant => participant.id !== participantId
    );
    setpartnerParticipants(newpartnerParticipants);
  };

  const handleRemoveCompanyParticipant = participantId => {
    setCompanyParticipants(prevParticipants =>
      prevParticipants.filter(participant => participant.id !== participantId)
    );
  };

  const handleScheduleMeetings = () => {
    // Cette fonction sera implémentée plus tard quand la fonctionnalité sera disponible
    toast('La planification des rendez-vous sera bientôt disponible');
  };

  const handleWishesUpdate = ({
    participantId,
    type,
    wishesCount,
    updatedWishes
  }) => {
    // Mettre à jour le compteur de vœux comme précédemment pour les participants
    if (type === 'partner') {
      // Mettre à jour le nombre de vœux pour les participants partenaire
      setpartnerParticipants(prevParticipants => {
        const updatedParticipants = prevParticipants.map(participant =>
          participant.id === participantId
            ? { ...participant, wishes_count: wishesCount }
            : participant
        );

        // Si le participant sélectionné est celui modifié, mettre à jour selectedParticipant aussi
        if (selectedParticipant && selectedParticipant.id === participantId) {
          const updatedParticipant = updatedParticipants.find(
            p => p.id === participantId
          );
          setSelectedParticipant({
            ...updatedParticipant,
            type,
            wishes: updatedWishes
          });
        }

        return updatedParticipants;
      });

      // Mise à jour du compteur de vœux pour le partenaire concerné
      const participant = partnerParticipants.find(p => p.id === participantId);
      if (participant) {
        setSalonPartners(prevPartners =>
          prevPartners.map(partner =>
            partner.id === participant.partner_id
              ? {
                  ...partner,
                  wishes_count: calculateEntityWishesCount(
                    partner.id,
                    'partner',
                    updatedWishes
                  )
                }
              : partner
          )
        );
      }
    } else {
      // Mettre à jour le nombre de vœux pour les participants entreprise
      setCompanyParticipants(prevParticipants => {
        const updatedParticipants = prevParticipants.map(participant =>
          participant.id === participantId
            ? { ...participant, wishes_count: wishesCount }
            : participant
        );

        // Si le participant sélectionné est celui modifié, mettre à jour selectedParticipant aussi
        if (selectedParticipant && selectedParticipant.id === participantId) {
          const updatedParticipant = updatedParticipants.find(
            p => p.id === participantId
          );
          setSelectedParticipant({
            ...updatedParticipant,
            type,
            wishes: updatedWishes
          });
        }

        return updatedParticipants;
      });

      // Mise à jour du compteur de vœux pour l'entreprise concernée
      const participant = companyParticipants.find(p => p.id === participantId);
      if (participant) {
        setSalonCompanies(prevCompanies =>
          prevCompanies.map(company =>
            company.id === participant.company_id
              ? {
                  ...company,
                  wishes_count: calculateEntityWishesCount(
                    company.id,
                    'company',
                    updatedWishes
                  )
                }
              : company
          )
        );
      }
    }
  };

  const calculateEntityWishesCount = (entityId, type, updatedWishes = null) => {
    if (type === 'partner') {
      const entityParticipants = partnerParticipants.filter(
        p => p.partner_id === entityId
      );
      let totalWishes = 0;

      entityParticipants.forEach(participant => {
        // Si les vœux mis à jour concernent ce participant, utiliser cette valeur
        if (updatedWishes && participant.id === selectedParticipant?.id) {
          totalWishes += updatedWishes.length;
        } else {
          totalWishes += participant.wishes_count || 0;
        }
      });

      return totalWishes;
    } else {
      const entityParticipants = companyParticipants.filter(
        p => p.company_id === entityId
      );
      let totalWishes = 0;

      entityParticipants.forEach(participant => {
        // Si les vœux mis à jour concernent ce participant, utiliser cette valeur
        if (updatedWishes && participant.id === selectedParticipant?.id) {
          totalWishes += updatedWishes.length;
        } else {
          totalWishes += participant.wishes_count || 0;
        }
      });

      return totalWishes;
    }
  };

  const handleParticipantsUpdate = (updatedEntity, type) => {
    if (type === 'partner') {
      // Mettre à jour le compteur de participants et de voeux pour le partenaire
      setSalonPartners(prevSalonPartners => {
        return prevSalonPartners.map(partner => {
          if (partner.id === updatedEntity.id) {
            return {
              ...partner,
              participants_count: updatedEntity.participants_count,
              wishes_count: updatedEntity.wishes_count
            };
          }
          return partner;
        });
      });
    } else {
      // Mettre à jour le compteur de participants et de voeux pour l'entreprise
      setSalonCompanies(prevSalonCompanies => {
        return prevSalonCompanies.map(company => {
          if (company.id === updatedEntity.id) {
            return {
              ...company,
              participants_count: updatedEntity.participants_count,
              wishes_count: updatedEntity.wishes_count
            };
          }
          return company;
        });
      });
    }
  };

  return (
    <>
      <PageHeader
        title={`Salon : ${salon.name || ''}`}
        breadcrumb={[
          { name: 'Accueil', path: '/admin' },
          { name: 'Salons Partenaires', path: '/admin/partner-salons' },
          { name: salon.name || '', active: true }
        ]}
      />
      <Card className="mt-3">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0">Détails du salon</h5>
            <div>
              <Button
                variant="falcon-info" // Changement de couleur pour distinguer
                size="sm"
                className="me-2"
                onClick={handleOpenLogsModal} // Handler pour ouvrir la modal des logs
              >
                <FontAwesomeIcon icon={faHistory} className="me-1" /> Voir les
                logs
              </Button>
              <Button
                variant="falcon-primary"
                size="sm"
                className="me-2"
                onClick={handleOpenPartnersModal}
              >
                <FontAwesomeIcon icon={faUsers} className="me-1" /> Gérer les
                partenaires
              </Button>
              <Button
                variant="falcon-primary"
                size="sm"
                className="me-2"
                onClick={handleOpenCompaniesModal}
              >
                <FontAwesomeIcon icon={faBuilding} className="me-1" /> Gérer les
                sociétés
              </Button>
              <Button
                variant="outline-primary"
                size="sm"
                className="me-2"
                onClick={handleOpenAllParticipantsModal}
              >
                <FontAwesomeIcon icon={faListAlt} className="me-1" />{' '}
                Participants
              </Button>
              <Link
                to={`/administration/salons-partenaires/${id}/modifier`}
                className="btn btn-falcon-default btn-sm"
              >
                <FontAwesomeIcon icon={faEdit} className="me-1" /> Modifier
              </Link>
            </div>
          </div>
          <SalonInfoCards salon={salon} />
        </Card.Body>
      </Card>
      <MeetingsCard salon={salon} />
      {/* Modal pour gérer les partenaires */}
      <ManageEntityModal
        show={showPartnersModal}
        onHide={() => setShowPartnersModal(false)}
        salonId={id}
        entities={salonPartners}
        allEntities={partners}
        participants={partnerParticipants}
        onEntitiesUpdate={handlePartnersUpdate}
        onOpenParticipants={handleOpenPartnerParticipantsOffcanvas}
        entityType="partner"
      />
      <ManageEntityModal
        show={showCompaniesModal}
        onHide={() => setShowCompaniesModal(false)}
        salonId={id}
        entities={salonCompanies}
        allEntities={companies}
        participants={companyParticipants}
        onEntitiesUpdate={handleCompaniesUpdate}
        onOpenParticipants={handleOpenCompanyParticipantsOffcanvas}
        entityType="company"
      />

      <ParticipantsOffcanvas
        show={showPartnerpartnerParticipantsOffcanvas}
        onHide={handleClosepartnerParticipantsOffcanvas}
        currentEntity={currentPartner}
        participants={partnerParticipants}
        newParticipant={newPartnerParticipant}
        onNewParticipantChange={handlenewPartnerParticipantChange}
        onAddParticipant={handleAddPartnerParticipant}
        onRemoveParticipant={handleRemovePartnerParticipant}
        entityType="partner"
        onOpenWishes={handleOpenParticipantWishesFromOffcanvas}
        salonId={id}
        onParticipantsUpdate={handleParticipantsUpdate}
      />

      <ParticipantsOffcanvas
        show={showCompanyParticipantsOffcanvas}
        onHide={handleCloseCompanyParticipantsOffcanvas}
        currentEntity={currentCompany}
        participants={companyParticipants}
        newParticipant={newCompanyParticipant}
        onNewParticipantChange={handleNewCompanyParticipantChange}
        onAddParticipant={handleAddCompanyParticipant}
        onRemoveParticipant={handleRemoveCompanyParticipant}
        entityType="company"
        onOpenWishes={handleOpenParticipantWishesFromOffcanvas}
        salonId={id}
        onParticipantsUpdate={handleParticipantsUpdate}
      />

      {/* Backdrop pour l'offcanvas si nécessaire */}
      {showCompanyParticipantsOffcanvas && (
        <div
          className="modal-backdrop fade show"
          style={{
            zIndex: 1056,
            opacity: 0.7
          }}
          onClick={handleCloseCompanyParticipantsOffcanvas}
        />
      )}

      {/* Modal pour afficher tous les participants */}
      <ParticipantsSummaryModal
        show={showAllParticipantsModal}
        onHide={() => setShowAllParticipantsModal(false)}
        partnerParticipants={partnerParticipants}
        companyParticipants={companyParticipants}
        salonPartners={salonPartners}
        salonCompanies={salonCompanies}
        onOpenWishes={handleOpenParticipantWishes}
        salon={salon}
      />
      <WishesModal
        show={showWishesModal}
        onHide={() => setShowWishesModal(false)}
        participant={selectedParticipant}
        salonId={id}
        salon={salon}
        onWishesUpdate={handleWishesUpdate}
      />
      <SalonLogsModal
        show={showLogsModal}
        onHide={handleCloseLogsModal}
        salonId={id}
        salonName={salon.name}
      />
    </>
  );
};

export default ShowPartnerSalons;
